import { StateCreator } from "zustand";
import alfredoIcon from "../../assets/alfredo-icon.svg";
import tableSvg from "../../assets/table.svg";
import counterSvg from "../../assets/counter.svg";
import deliverySvg from "../../assets/delivery.svg";
import { enderecoPadraoDoAmbiente } from "../../services/enderecoApi.service";
import {
  PADRAO_BOTAO_ESTADO_INICIAL,
  PADRAO_LOGO_ESTADO_INICIAL,
} from "../../dominio/padroesDaHome";

interface SubsidiaryInfo {
  subsidiaryName?: string;
  subsidiaryLogoUrl?: string;
  subsidiaryAddress?: string;
  subsidiaryTaxPayerID?: string;
  subsidiaryVirtualAddress: string;
  subsidiaryManager?: string;
  subsidiaryInfo?: any;
  pdvs?: [
    {
      itemUuid: string;
      itemName: string;
      itemLogoUrl: string;
    }
  ];
  employees?: [
    {
      userUuid: string;
      userName: string;
      userSurname: string;
      userSocialName: string;
      userEmail: string;
      userLogoUrl: string;
    }
  ];
  //QUANDO O USUARIO SELECIONAR O CAIXA, SEM TER UM PERIODO ABERTO, ATUALIZAREMOS ESSE ESTADO:
  selectedPdv: {
    [key: string]: string | number | boolean | undefined | object | null;
    itemUuid: string;
    itemName: string;
    itemLogoUrl: string;
    homeInfo: {
      itemInfoUuid: string;
      itemInfoName: string;
      itemInfoDescription: string;
      itemInfoType: string;
      itemInfoValue: {
        initialCashBalance: number;
        askInitialCashBalance: boolean;
        logo?: string;
        logoWidth: string;
        logoHeight: string;
        tableSvg: string;
        counterSvg: string;
        deliverySvg: string;
        backgroundColor: string;
        buttonsColor: string;
        textColor: string;
        homeTitle: string;
        defaultPrinterAddress?: string;
        buttonsWidth: string;
        buttonsHeight: string;
      };
    };
    saleOptions: Array<{
      itemInfoType: string;
      itemInfoName: string;
      itemInfoDescription: string;
      itemInfoUuid: string;
      itemInfoStatus: boolean;
      itemInfoValue: {
        saleOptionName: string;
        saleOptionType: string;
        saleOptionPrinterAddress: string;
        saleOptionImg: string;
        saleOptionImgWidth: string;
        saleOptionImgHeight: string;
        saleOptionWidth: string;
        saleOptionHeight: string;
        saleOptionBackgroundColor: string;
        saleOptionBackgroundBrightness: string;
        saleOptionComponents: Array<{
          componentSelected: boolean;
          componentId: string;
          componentType: string;
          componentProps: {
            [key: string]: string | number | boolean | undefined | object;
            componentFocus?: boolean;
            componentPosition: {
              x: string;
              y: string;
            };
            componentShortcut: string;
            componentLabel?: string;
            componentBrightness: string;
            componentWidth: string;
            componentHeight: string;
            componentFontSize?: string;
            componentColor?: string;
            componentValue?: string;
            componentColumns?: {
              columnId: string;
              columnLabel: string;
              columnWidth: string;
              columnStatus: boolean;
            }[];
            componentRows?: {
              rowId: string;
              rowLabel: string;
              rowInfo: string;
              rowValue: string;
              rowStatus: boolean;
            }[];
          };
          componentStatus: boolean;
        }>;
      };
    }>;
    lastPeriod?: {
      periodUuid: string;
      periodTypeName: string;
      orders: number;
      tableOrders: number;
      counterOrders: number;
      deliveryOrders: number;
      createdAt: string;
      updatedBy: string;
      updatedAt: string;
    };
    selectedPeriod?: any; // TODO
    selectedOrder?: any; // TODO

    // Versão da configuração servida pelo OPS. Muda quando qualquer itemInfo
    // deste PDV muda; é o sinal para a tela se recarregar (useConfigDoPdv).
    configVersao?: string;

    // O que a Central salvou e ainda não entrou nesta tela.
    configPendente?: {
      aguardandoProximoPeriodo: {
        eventoUuid: string;
        itemInfoNome: string | null;
        criadoEm: string;
      }[];
      aCaminhoAgora: number;
      conflitos: {
        eventoUuid: string;
        itemInfoNome: string | null;
        erro: string;
      }[];
    };
  };
}

export interface SubsidiarySlice {
  subsidiaryDataZustand: SubsidiaryInfo;

  setSubsidiaryDataZustand: (subsidiaryInfo: SubsidiaryInfo) => void;
}

export const createSubsidiarySlice: StateCreator<SubsidiarySlice> = (
  set: any
) => ({
  subsidiaryDataZustand: {
    // Nasce com REACT_APP_API_URL quando existe (é assim que a instância de
    // nuvem já abre apontando para o alfredo-ops-api). Na loja a variável não
    // existe, fica "" e o PDV pergunta o endereço, como sempre fez.
    subsidiaryVirtualAddress: enderecoPadraoDoAmbiente(),
    selectedPdv: {
      itemUuid: "",
      itemName: "",
      itemLogoUrl: "",
      homeInfo: {
        itemInfoUuid: "",
        itemInfoName: "",
        itemInfoDescription: "",
        itemInfoType: "",
        itemInfoValue: {
          initialCashBalance: 0,
          askInitialCashBalance: false,
          logo: alfredoIcon,
          logoWidth: PADRAO_LOGO_ESTADO_INICIAL,
          logoHeight: PADRAO_LOGO_ESTADO_INICIAL,
          tableSvg: tableSvg,
          counterSvg: counterSvg,
          deliverySvg: deliverySvg,
          backgroundColor: "#BBCAFF",
          buttonsColor: "#1D50FF",
          textColor: "white",
          homeTitle: "Bem Vindo ao Alfredo",
          buttonsWidth: PADRAO_BOTAO_ESTADO_INICIAL,
          buttonsHeight: PADRAO_BOTAO_ESTADO_INICIAL,
        },
      },
      saleOptions: [
        {
          itemInfoType: "",
          itemInfoName: "",
          itemInfoDescription: "",
          itemInfoUuid: "",
          itemInfoStatus: false,
          itemInfoValue: {
            saleOptionName: "",
            saleOptionType: "",
            saleOptionPrinterAddress: "",
            saleOptionImg: "",
            saleOptionImgWidth: "",
            saleOptionImgHeight: "",
            saleOptionBackgroundColor: "",
            saleOptionBackgroundBrightness: "",
            saleOptionWidth: "",
            saleOptionHeight: "",
            saleOptionComponents: [
              {
                componentSelected: false,
                componentId: "",
                componentShortcut: "",
                componentType: "",
                componentProps: {
                  componentPosition: {
                    x: "",
                    y: "",
                  },
                  componentShortcut: "",
                  componentBrightness: "",
                  componentWidth: "",
                  componentHeight: "",
                },
                componentStatus: false,
              },
            ],
          },
        },
      ],
    },
  },
  setSubsidiaryDataZustand: (subsidiaryInfo) =>
    set({ subsidiaryDataZustand: subsidiaryInfo }),
});
